import React, { Component } from "react";
import Menu from "./Menu";

class Welcome extends Component {
	render() {
		return (
			<div>
				<Menu selected='welcome' />
				<div className='row maincontent shadow'>
					<div className='col'>
						<div className='container'>
							<h2>New Project</h2>
							<div className='row'>
								<div className='col'>
									<p>
										Lorem ipsum dolor sit amet consectetur adipisicing elit.
										Impedit dignissimos voluptatem amet ab perferendis molestiae
										inventore deleniti voluptas blanditiis ratione illo
										aspernatur nisi, fugit asperiores, culpa unde nam neque
										laboriosam. Architecto expedita neque numquam atque maxime.
										Inventore, a! Nesciunt asperiores veniam enim tempora
										cupiditate eaque rem id ipsum illum blanditiis amet, harum,
										porro ab dolorem, sapiente modi eos tenetur! Quis?
									</p>
								</div>
								<div className='col'>
									<img
										src='https://picsum.photos/700/500'
										alt=''
										className='img-fluid'
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Welcome;
